"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
// genero version
const SimpleForm = ({ className, method, onSubmit, children }) => {
    const handleSubmit = (evt) => {
        evt.preventDefault();
        if (onSubmit) {
            onSubmit();
        }
    };
    return (react_1.default.createElement("form", { className: className, method: method, onSubmit: handleSubmit, encType: "multipart/form-data" }, children));
};
exports.default = SimpleForm;
//# sourceMappingURL=index.js.map